export default "__VITE_ASSET__Dju8Yai7__"